import cn from 'clsx'
import { Text } from '@/components/Text/Text'
import type { TextSize } from '@/components/Text/Text'
import { HyperLink } from '@/components/hyper-link/hyper-link'

import css from './meta-pill.module.css'

import type { BoxProps } from '@/components/Box/Box'

interface CommonProps extends Omit<BoxProps, 'size'> {
    className?: string
    size?: 'base' | 'small'
    children: React.ReactNode
}

type MetaPillLinkProps = {
    href: string
    target?: string
    disabled?: boolean
}

type MetaPillStandardProps = {
    href?: never
    target?: never
    disabled?: never
}
export type MetaPillProps = CommonProps & (MetaPillLinkProps | MetaPillStandardProps)

const sizeToTextSize = new Map<NonNullable<CommonProps['size']>, TextSize>([
    ['base', 'minor-sm'],
    ['small', 'body-2xs'],
])

export function MetaPill({
    className,
    size = 'base',
    href,
    target,
    children,
    tag = 'li',
    disabled = false,
    ...rest
}: MetaPillProps) {
    return (
        <Text
            tag={tag}
            className={cn(css.metapill, className, {
                [css.disabled]: disabled,
            })}
            size={sizeToTextSize.get(size)}
            {...rest}
        >
            {href && !disabled ? (
                <HyperLink
                    className={cn(css.inner, css[size], css.link)}
                    size="inherit"
                    href={href}
                    target={target}
                >
                    {children}
                </HyperLink>
            ) : (
                <span className={cn(css.inner, css[size])}>{children}</span>
            )}
        </Text>
    )
}
